// extracted by mini-css-extract-plugin
export default {"timberGreen":"#005826","darkBlue":"#006581","perennialGreen":"#87c540","coniferGreen":"#365004","simpleGray":"#f7f7f7"};